module.exports = __webpack_public_path__ + "img/payshop.6a41cd2.svg";